import { Address, Contact, TODO, UIBModal } from '@b2b/types/core';
import { Organization } from '@b2b/types/organization';
import uiRouter from '@uirouter/angularjs';
import angular, { IScope } from 'angular';
import { VCardEditDirectiveModule } from './edit/edit.directive';

function VCardDirective() {
  VCardDirectiveController.$inject = ['$scope', '$uibModal'];

  function VCardDirectiveController($scope: IScope & { vcard: TODO }, $uibModal: UIBModal<TODO>) {
    const ctrl = {
      id: '',
      fullName: '',

      address: {} as Partial<Address>,
      contact: {} as Partial<Contact>,
      organization: {} as Partial<Organization>,

      init: function () {
        $scope.$on('$destroy', $scope.$watch('contact', this.onContactUpdate));

        // $scope.$on('$destroy', $scope.$watch('address',  function(n, o) {
        //   ctrl.address = n;
        // }));

        $scope.$on('$destroy', $scope.$watch('organization', this.onOrganizationUpdate));
      },

      generateId: function () {
        var id = ['hcard'];

        if (ctrl.contact.firstName) {
          id.push(ctrl.contact.firstName.toLowerCase());
        }
        if (ctrl.contact.lastName) {
          id.push(ctrl.contact.lastName.toLowerCase());
        }

        return id.join('-');
      },

      generateFullName: function () {
        const name: string[] = [];

        if (ctrl.contact.salutation) {
          name.push(ctrl.contact.salutation);
        }

        if (ctrl.contact.prefix) {
          name.push(ctrl.contact.prefix);
        }

        if (ctrl.contact.firstName) {
          name.push(ctrl.contact.firstName);
        }

        if (ctrl.contact.middleName) {
          name.push(ctrl.contact.middleName);
        }

        if (ctrl.contact.lastName) {
          name.push(ctrl.contact.lastName);
        }

        if (!ctrl.contact.firstName && !ctrl.contact.lastName && ctrl.contact.name) {
          name.push(ctrl.contact.name);
        }

        if (ctrl.contact.postfix) {
          name.push(ctrl.contact.postfix);
        }

        return name.join(' ');
      },

      isCardType: function (type) {
        return ctrl.contact && ctrl.contact.cardType && ctrl.contact.cardType === type;
      },

      getMapLink: function () {
        var url = 'https://www.google.com/maps/search/?api=1&query=';

        return (
          url +
          encodeURIComponent(
            [
              this.address.streetAddress1,
              this.address.streetAddress2,
              this.address.city,
              this.address.state,
              this.address.zip,
              this.address.country,
            ].join(' ')
          )
        );
      },

      onContactUpdate: function (n, o) {
        if (n) {
          ctrl.contact = n;

          if (n.address) {
            ctrl.address = n.address;
          } else {
            ctrl.address = {};
          }

          ctrl.id = ctrl.generateId();
          ctrl.fullName = ctrl.generateFullName();
        }
      },

      onOrganizationUpdate: function (n, o) {
        if (n) {
          ctrl.organization = n;
        }
      },
    };

    $scope.vcard = ctrl;
    ctrl.init();
  }

  return {
    restrict: 'A',
    replace: true,
    transclude: true,
    templateUrl: 'common/directives/vcard/vcard.tpl.html',
    scope: {
      contact: '=',
      // address: '=?',
      primaryTitle: '@',
      organization: '=?',
      enableLinks: '@',
      enableIcons: '@',
      layout: '@',
      flat: '@',
      primaryLink: '@',
      enableActions: '@',
      isMemberCard: '@',
      customerAction: '&',
      memberAction: '&',
      contactMeta: '=',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: VCardDirectiveController,
  };
}

export const VCardDirectiveModule = angular
  .module('acme.common.directive.vcard', [uiRouter, VCardEditDirectiveModule])
  .directive('vcard', VCardDirective).name;
